module.exports = __webpack_public_path__ + "img/scan-code-login.366cc46e.png";